import Helmet from 'react-helmet';

import { DefaultSheet } from 'twyne-new.ui';

import { useParams } from '@Components/RouterProvider';
import app from '@Stores/app';
import history from 'utils/history';

import { useAllocationStore } from '../store';

import Form from './URLGeneratorForm'

function FormURLGenerator() {
  const { collection: { useLoad, item, reset }, lists: { offers: { useLoad: useLoadOffers, items: offers }, forms: { useLoad: useLoadForms, items: forms } } } = useAllocationStore()
  const { id } = useParams()

  useLoad(id)
  useLoadOffers()
  useLoadForms()

  const handleClickSidebarClose = () => {
    history.push('/offer/allocations');
    reset()
  }

  if (!item) return null

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClickSidebarClose() }}
    title='Allocation URL Generator'
  >
    <Helmet title="URL Generator" />
    <Form
      offers={offers}
      forms={forms}
      allocationData={item}
      siteData={app.site}
      onCancel={handleClickSidebarClose}
    />
  </DefaultSheet>
}

FormURLGenerator.propTypes = {};

export default FormURLGenerator;
